<script type="text/ecmascript-6">
    import DesignerQuestionHardwareNumeral from "../DesignerQuestionHardwareNumeral.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareNumeral,
            SynsealQuestion,
        ],
    }
</script>
